import DropInVideoPlayer from './DropInVideoPlayer'

export default DropInVideoPlayer
// eslint-disable-next-line import/export
export * from './DropInVideoPlayer'
